var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"title":"快捷功能"}},[_c('a-row',_vm._l((_vm.filteredList),function(item){return _c('a-col',{key:item.id,attrs:{"span":6}},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.route(item.path)}}},[_c('img',{attrs:{"src":item.imagePath,"alt":"系统图标"}}),_c('div',[_vm._v(_vm._s(item.title))])])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }